export default [
  //COUNCIL PROFILE
  {
    path: '/councils',
    name: 'profile-council',
    component: () => import('@/views/profiles/council/Index.vue'),
    meta: {
      resource: 'Profile-Council',
      action: 'read',
      pageTitle: 'Council Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Council',
          active: true,
        },
      ],
    },
  },

  //AREA PROFILE
  {
    path: '/areas',
    name: 'profile-area',
    component: () => import('@/views/profiles/area/Index.vue'),
    meta: {
      resource: 'Profile-Area',
      action: 'read',
      pageTitle: 'Area Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Area',
          active: true,
        },
      ],
    },
  },

//PONDOK PROFILE
  {
    path: '/pondoks',
    name: 'profile-pondok',
    component: () => import('@/views/profiles/pondok/Index.vue'),
    meta: {
      resource: 'Profile-Pondok',
      action: 'read',
      pageTitle: 'Pondok Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Pondok',
          active: true,
        },
      ],
    },
  },

  //AREA PROFILE
  {
    path: '/agents',
    name: 'profile-agent',
    component: () => import('@/views/profiles/agent/Index.vue'),
    meta: {
      resource: 'Profile-Agent',
      action: 'read',
      pageTitle: 'Agent Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Agent',
          active: true,
        },
      ],
    },
  },

  //OFFENCE PROFILE
  {
    path: '/offences',
    name: 'profile-offence',
    component: () => import('@/views/profiles/offence/Index.vue'),
    meta: {
      resource: 'Profile-Offence',
      action: 'read',
      pageTitle: 'Offence Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Offence',
          active: true,
        },
      ],
    },
  },

  //HOLIDAY PROFILE
  {
    path: '/holidays',
    name: 'profile-holiday',
    component: () => import('@/views/profiles/holiday/Index.vue'),
    meta: {
      resource: 'Profile-Holiday',
      action: 'read',
      pageTitle: 'Holiday Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Holiday',
          active: true,
        },
      ],
    },
  },

  //COMPANY PROFILE
  {
    path: '/company',
    name: 'profile-company',
    component: () => import('@/views/profiles/company/Index.vue'),
    meta: {
      resource: 'Profile-Company',
      action: 'read',
      pageTitle: 'Company Profile',
      breadcrumb: [
        {
          text: 'Profiles',
        },
        {
          text: 'Company',
          active: true,
        },
      ],
    },
  },
]
